// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@guestsupply/Overrides/Widgets/MyLists/MyListsFilter";
import { color, mergeWithCss } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

filterStyles.filterContainer = {
    css: css`
        position: relative;
        padding-top: 54px;
    `,
};

filterStyles.container = {
    css: css`
        border: 1px solid ${color("common.border")};
        position: relative;
        padding: 10px 15px;
    `,
};

filterStyles.toggleFilterButton = {
    ...mergeWithCss(myAccountFilterSectionStyles.toggleFilterButton, {
        css: css`
            position: absolute;
            top: 0;
            z-index: 1;
        `,
    }),
};

filterStyles.toggleFilterButtonIcon = {
    ...myAccountFilterSectionStyles.toggleFilterButtonIcon,
};
